import { TheWrapper } from '@hyphengroup/cms-components/components/TheWrapper';
import { ComponentParagraph } from '$/(cms)/_modules/cmsService/types';

export const Paragraph: React.FC<ComponentParagraph> = ({ contentText }) => {
  return (
    <TheWrapper type="simple">
      <p className="pb-0 alpha-body-2">{contentText}</p>
    </TheWrapper>
  );
};
